import { createDelugeTheme } from './theme-create';
import { darkPalette } from './theme-palette';
// #8D7DD8
const purple = {
    [1]: '#11101a',
    [2]: '#181623',
    [3]: '#26213e',
    [4]: '#312953',
    [5]: '#3a325f',
    [6]: '#453c6d',
    [7]: '#544a81',
    [8]: '#685c9f',
    [9]: '#8d7dd8',
    [10]: '#8171cb',
    [11]: '#b6abf7',
    [12]: '#e1def9',
};
const purpleA = {
    [1]: '#1200f70a',
    [2]: '#6b51f714',
    [3]: '#7f65fc31',
    [4]: '#8468ff47',
    [5]: '#8e76fe54',
    [6]: '#9780fe63',
    [7]: '#a08bff78',
    [8]: '#a28efe99',
    [9]: '#a591fed6',
    [10]: '#a08bfec8',
    [11]: '#bbb0fef7',
    [12]: '#e6e3fff9',
};
// #a9dc76
const greenCandle = {
    [1]: '#0f120c',
    [2]: '#151911',
    [3]: '#202918',
    [4]: '#2a371e',
    [5]: '#344424',
    [6]: '#3f522c',
    [7]: '#4b6233',
    [8]: '#58753b',
    [9]: '#a9dc76',
    [10]: '#9fd16c',
    [11]: '#acdf79',
    [12]: '#d9f5c1',
};
const greenCandleA = {
    [1]: '#00910002',
    [2]: '#83f41209',
    [3]: '#a5fd561a',
    [4]: '#adfe6229',
    [5]: '#b4fe6a37',
    [6]: '#b9fe7446',
    [7]: '#bbff7557',
    [8]: '#b9fd746c',
    [9]: '#c3ff88da',
    [10]: '#c1ff82ce',
    [11]: '#c4ff89dd',
    [12]: '#e1fec8f5',
};
// #FFD866
const yellow = {
    [1]: '#13110c',
    [2]: '#1b1811',
    [3]: '#2a230d',
    [4]: '#372b03',
    [5]: '#433505',
    [6]: '#514217',
    [7]: '#645427',
    [8]: '#7f6b34',
    [9]: '#ffd866',
    [10]: '#f5ce5b',
    [11]: '#fdd664',
    [12]: '#faeabe',
};
const yellowA = {
    [1]: '#bb110003',
    [2]: '#f9b4120b',
    [3]: '#febb001b',
    [4]: '#feb30029',
    [5]: '#febb0036',
    [6]: '#fec72845',
    [7]: '#ffd15159',
    [8]: '#ffd45d76',
    [9]: '#ffd866',
    [10]: '#fed55ef5',
    [11]: '#ffd865fd',
    [12]: '#ffefc2fa',
};
// base #2CAF35 https://www.radix-ui.com/colors/custom
const green = {
    [1]: '#0c130c',
    [2]: '#131a13',
    [3]: '#192b19',
    [4]: '#1a3b1a',
    [5]: '#204a20',
    [6]: '#275927',
    [7]: '#2d6a2e',
    [8]: '#337c34',
    [9]: '#2caf35',
    [10]: '#16a226',
    [11]: '#5fd561',
    [12]: '#b8f4b6',
};
const greenA = {
    [1]: '#00bb0003',
    [2]: '#45f7450a',
    [3]: '#5afe5a1c',
    [4]: '#44ff442d',
    [5]: '#4ffc4f3e',
    [6]: '#59fd594e',
    [7]: '#5bfd5e60',
    [8]: '#5dff5f73',
    [9]: '#39fe47aa',
    [10]: '#19fe339c',
    [11]: '#70ff72d2',
    [12]: '#bffebdf4',
};
const pink = {
    [1]: '#170e10',
    [2]: '#1f1415',
    [3]: '#3a141d',
    [4]: '#501022',
    [5]: '#60172b',
    [6]: '#712337',
    [7]: '#8a3247',
    [8]: '#b5415e',
    [9]: '#ff6188',
    [10]: '#f1547d',
    [11]: '#ff8ca6',
    [12]: '#ffd2d9',
};
const pinkA = {
    [1]: '#ec000007',
    [2]: '#ff44550f',
    [3]: '#ff23572c',
    [4]: '#fe0e5144',
    [5]: '#ff235f55',
    [6]: '#ff3e7067',
    [7]: '#ff527b82',
    [8]: '#ff5781b0',
    [9]: '#ff6188',
    [10]: '#ff5884f0',
    [11]: '#ff8ca6',
    [12]: '#ffd2d9',
};
// base #E5434B https://www.radix-ui.com/colors/custom
const red = {
    [1]: '#170f0e',
    [2]: '#201312',
    [3]: '#3b1212',
    [4]: '#510e12',
    [5]: '#62151a',
    [6]: '#742325',
    [7]: '#8d3334',
    [8]: '#b74345',
    [9]: '#e5434b',
    [10]: '#d6333f',
    [11]: '#ff8f8c',
    [12]: '#ffd1ce',
};
const redA = {
    [1]: '#ec000007',
    [2]: '#f22f2011',
    [3]: '#ff17172d',
    [4]: '#fe061545',
    [5]: '#ff1d2c57',
    [6]: '#fd3c416b',
    [7]: '#ff535585',
    [8]: '#ff595cb2',
    [9]: '#fe4952e4',
    [10]: '#fe3a48d4',
    [11]: '#ff8f8c',
    [12]: '#ffd1ce',
};
// base #2D2A2E https://www.radix-ui.com/colors/custom
const gray = {
    [1]: '#121012',
    [2]: '#1a191b',
    [3]: '#242225',
    [4]: '#2c292d',
    [5]: '#333035',
    [6]: '#3d393e',
    [7]: '#4b464d',
    [8]: '#645f66',
    [9]: '#726d74',
    [10]: '#7f7a81',
    [11]: '#b7b2b9',
    [12]: '#efeeef',
};
const grayA = {
    [1]: '#91009102',
    [2]: '#e2cbf90b',
    [3]: '#edd6f916',
    [4]: '#f7ddff1e',
    [5]: '#f0dcfd27',
    [6]: '#f6e2fc31',
    [7]: '#f5e1fd41',
    [8]: '#f8eafd5c',
    [9]: '#f9edfd6b',
    [10]: '#fbf1ff78',
    [11]: '#fcf5ffb4',
    [12]: '#fffeffee',
};
export const monokaiTheme = createDelugeTheme({
    appearance: 'dark',
    appearanceColor: '#111111',
    palette: {
        ...darkPalette,
        gray: gray,
        grayA: grayA,
        text: gray,
        textA: grayA,
        background: gray,
        backgroundA: grayA,
        primary: purple,
        primaryA: purpleA,
        candleGreen: greenCandle,
        candleGreenBorder: greenCandle,
        candleGreenWick: greenCandle,
        candleGreenA: greenCandleA,
        candleGreenBorderA: greenCandleA,
        candleGreenWickA: greenCandleA,
        up: greenCandle,
        upA: greenCandleA,
        upAccent: green,
        upAccentA: greenA,
        candleRed: pink,
        candleRedBorder: pink,
        candleRedWick: pink,
        candleRedA: pinkA,
        candleRedBorderA: pinkA,
        candleRedWickA: pinkA,
        down: pink,
        downA: pinkA,
        downAccent: red,
        downAccentA: redA,
        neutral: gray,
        neutralA: grayA,
        neutralAccent: gray,
        neutralAccentA: grayA,
        warning: yellow,
        warningA: yellowA,
        warningAccent: yellow,
        warningAccentA: yellowA,
        success: green,
        successA: greenA,
        successAccent: green,
        error: red,
        errorA: redA,
        errorAccent: red,
    },
    fontFamily: `"Inter", sans-serif;`,
});
//# sourceMappingURL=monokai-theme.js.map